import styles from "./ShortsAiSummary.module.scss"

import React, { useState } from "react"

import aiIcon from "@shared/assets/images/ai-summary.svg"
import { isEmptyStr } from "@shared/modules"

import dayjs from "dayjs"
import AiSummaryPopup from "live/components/sidebar/contents/ShortForm/AiSummaryPopup"
import { useShortsDetail } from "vod/contexts"

export default function ShortsAiSummary() {
  const shortsDetail = useShortsDetail()
  const [isOpen, setIsOpen] = useState(false)

  if (!shortsDetail) return null

  const { title, createdAt, nickname } = shortsDetail

  return (
    <>
      <div className={styles.card}>
        <div className={styles.inner}>
          <div className={styles.content}>
            <div className={styles.title}>
              <img src={aiIcon} alt="" width={20} height={20} />
              <span>AI 요약</span>
            </div>
            <div className={styles.textContainer}>
              <p className={styles.shortsTitle}>
                {isEmptyStr(title) ? "-" : title}
              </p>
              <p className={styles.date}>
                {createdAt ? dayjs(createdAt).format("YYYY-MM-DD") : "-"}
              </p>
            </div>
          </div>
          <button
            type="button"
            className={styles.button}
            onClick={() => setIsOpen(true)}
          >
            AI 요약 보기
          </button>
        </div>
      </div>

      {isOpen && (
        <AiSummaryPopup
          item={shortsDetail}
          streamerNickname={nickname ?? "-"}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
